import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=097bc7fc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=097bc7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bc7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097bc7fc')) {
      api.createRecord('097bc7fc', component.options)
    } else {
      api.reload('097bc7fc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=097bc7fc&scoped=true&", function () {
      api.rerender('097bc7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aEMnt2TdMfVB/JS/comp/CookieBox.vue"
export default component.exports